import React from "react";

const sectors = [
  "Medical Devices",
  "Aerospace",
  "Defence",
  "Industrial Automation",
  "Dental Systems",
  "Pharma & Chemical",
  "Industrial Electronics",
];

export default function TrustBar() {
  const item = (key, label) => (
    <div
      key={key}
      className="flex items-center gap-6 shrink-0"
      data-testid={`trustbar-item-${key}`}
    >
      <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-sebyx-muted">
        {label}
      </span>
      <span className="block w-1.5 h-1.5 rotate-45 bg-sebyx-accent" />
    </div>
  );

  return (
    <section
      data-testid="trust-bar"
      className="relative border-y border-sebyx-border bg-sebyx-surface py-6"
    >
      <div className="absolute left-0 top-0 bottom-0 w-px bg-sebyx-accent/40" />
      <div className="flex items-center gap-8 px-6 md:px-12 lg:px-24">
        <div className="hidden md:flex items-center gap-3 shrink-0 pr-6 border-r border-sebyx-border">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-sebyx-text">
            Specialized Expertise
          </span>
        </div>
        <div className="sebyx-marquee flex-1">
          <div className="sebyx-marquee__track">
            {sectors.map((s, i) => item(`a-${i}`, s))}
          </div>
          <div className="sebyx-marquee__track" aria-hidden="true">
            {sectors.map((s, i) => item(`b-${i}`, s))}
          </div>
        </div>
      </div>
    </section>
  );
}
